import React from "react";
import { Box, Typography } from "@mui/material";

const ComingSoonCard = () => {
    return (
        <Box
            sx={{
                background: "linear-gradient(90deg, #5b3ce6 0%, #8e3deb 100%)",
                borderRadius: "16px",
                padding: "4px 12px",
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
                boxShadow: "0px 2px 4px rgba(0,0,0,0.2)",
            }}
        >
            <Typography
                sx={{
                    fontSize: "0.75rem",
                    fontWeight: "bold",
                    letterSpacing: "0.5px",
                    display: "flex",
                    gap: "4px",
                }}
            >
                <span style={{ color: "#ffffff" }}>Coming</span>
                <span style={{ color: "#fbbd86" }}>Soon!</span>
            </Typography>
        </Box>
    );
};

export default ComingSoonCard;
